import React from 'react';
import { BookingSection } from '../components/BookingSection';

export const BookingPage = () => {
  return (
    <div className="min-h-screen bg-background pt-20">
      <BookingSection />
    </div>
  );
};
